import { render, staticRenderFns } from "./ViewAddress.vue?vue&type=template&id=73d1d3bb"
import script from "./ViewAddress.vue?vue&type=script&lang=js"
export * from "./ViewAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports